/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Return_Decision_PendingInputs */

const vi_carrier_return_decision_pending = /** @type {(inputs: Carrier_Return_Decision_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang chờ xác nhận phản hồi từ hãng`)
};

/**

* @param {Carrier_Return_Decision_PendingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_return_decision_pending = /** @type {((inputs?: Carrier_Return_Decision_PendingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Return_Decision_PendingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_return_decision_pending(inputs)
});